import { createSelector } from 'reselect';
import _get from 'lodash/get';

const selectInternalMetricsTable = (state) => state.baus.internalMetrics;

// TODO: incorporate into internal metrics component
export const selectProjectsTableTotal = (state) =>
  state.baus.internalMetrics.organizationMetrics.total;
export const selectProjectsTableIsLoading = (state) =>
  state.baus.internalMetrics.organizationMetrics.isLoading;
export const selectAdminUsers = (state) => state.baus.internalMetrics.users;
const getOrganizationMetrics = (state) =>
  _get(selectInternalMetricsTable(state), ['organizationMetrics', 'organization']);

export const formatInternalMetricsTableData = (data) => {
  const tableHeaderKeys = [
    'enabledOrganizations',
    'enabledProjects',
    'allLists',
    'allTemplates',
    'allCampaigns',
    'allWorkflows',
  ];

  let formattedData = [];
  if (data) {
    formattedData = tableHeaderKeys.map((key) => {
      switch (key) {
        case 'enabledOrganizations':
          return {
            name: data[key] ? data[key].length : 0,
          };
        case 'enabledProjects':
        case 'allLists':
        case 'allTemplates':
        case 'allCampaigns':
        case 'allWorkflows':
        default:
          return {
            name: data[key],
          };
      }
    });
  } else {
    formattedData = [];
  }

  const formattedHeaders = tableHeaderKeys.map((header /*: string */) => {
    const headerNames = {
      enabledOrganizations: 'Enabled Organizations',
      enabledProjects: 'Enabled Projects',
      allLists: 'All Lists',
      allTemplates: 'All Templates',
      allCampaigns: 'All Campaigns',
      allWorkflows: 'All Workflows',
    };
    return { id: header, name: headerNames[header] };
  });
  return { headers: formattedHeaders, data: formattedData };
};

export const formatUsersData = (users) =>
  users.map(({ orgName, orgId, email }) => ({
    subText: `Org Id: ${orgId} | ${orgName}`,
    value: email,
    text: email,
    searchtext: `${orgId} ${orgName} ${email}`.toLowerCase(),
  }));

export const formatProjectsData = (projects) => {
  let projectsData = [];
  if (projects) {
    projectsData = projects.map((row) => {
      const projectObj = {};
      projectObj.organizationId = row.project.organizationId;
      projectObj.id = row.project.id;
      projectObj.name = row.project.name;
      projectObj.isArchived = row.project.extendedProjectSettings.isArchived ? 'No' : 'Yes';
      Object.keys(row.usage).forEach((key) => {
        projectObj[key] = row.usage[key];
      });
      projectObj.catalogTotalCount =
        _get(projectObj, 'catalogLookupCount', 0) + _get(projectObj, 'catalogCollectionCount', 0);
      return projectObj;
    });
  }
  return projectsData;
};

export const selectInternalMetricsTableData = createSelector(
  selectInternalMetricsTable,
  (internalMetricsTable) => formatInternalMetricsTableData(internalMetricsTable.data),
);

export const selectFormattedAdminUsers = createSelector(selectAdminUsers, (users) =>
  users ? formatUsersData(users) : users,
);

export const selectAdminUsersForFormSelect = createSelector(selectAdminUsers, (users) =>
  (users || []).map((user) => ({
    label: `${user.email} - Org Id: ${user.orgId} | ${user.orgName}`,
    value: user,
  })),
);

export const selectOrganizationMetricsData = createSelector(
  getOrganizationMetrics,
  (organization) =>
    organization
      ? Object.keys(organization).reduce(
          (accumulator, key) => ({
            ...accumulator,
            [key]: organization[key],
          }),
          {
            catalogTotalCount:
              _get(organization, 'catalogLookupCount', 0) +
              _get(organization, 'catalogCollectionCount', 0),
          },
        )
      : undefined,
);

export const selectProjectsData = createSelector(
  selectInternalMetricsTable,
  (internalMetricsTable) =>
    internalMetricsTable.organizationMetrics
      ? formatProjectsData(internalMetricsTable.organizationMetrics.projects)
      : {},
);
